import { required, requiredIf } from "vuelidate/lib/validators";
import fileType from "@/validation/fileType";
import fileSizeMin from "@/validation/fileSizeMin";
import fileSizeMax from "@/validation/fileSizeMax";

const step4 = [
  "form.q_4_1",
  "form.q_4_3",
  "form.q_4_4",
  "form.q_4_5",
  "form.q_4_5a",
  "form.q_4_5b",
  "form.q_4_5c",
  "form.q_4_5d",
  "form.q_4_6",
  "form.q_4_6a",
  "form.files.programmeFull",
  "form.files.programmeBrief"
];

const require45 = function(m) {
  return this.form.q_4_5 === true;
};

const require46 = function(m) {
  return this.form.q_4_6 === true;
};

const hasFileOfType = function(files, type) {
  return files.filter(item => item.type === type).length > 0;
};

const requireProgrammeFull = function() {
  return (
    this.form.q_4_1 === true && !hasFileOfType(this.form.files, "programme")
  );
};

const requireProgrammeBrief = function() {
  return this.form.q_4_1 === false && !hasFileOfType(this.form.files, "brief");
};

const step4Validations = {
  q_4_1: { required },
  q_4_3: { required },
  q_4_4: { required },
  q_4_5: { required },
  q_4_5a: { required: requiredIf(require45) },
  q_4_5b: { required: requiredIf(require45) },
  q_4_5c: { required: requiredIf(require45) },
  q_4_5d: { required: requiredIf(require45) },
  q_4_6: { required },
  q_4_6a: { required: requiredIf(require46) },

  files: {
    programmeFull: {
      required: requiredIf(requireProgrammeFull),
      fileType: fileType(["pdf", "doc", "docx"]),
      fileSizeMin: fileSizeMin(1),
      fileSizeMax: fileSizeMax(20 * 1024 * 1024)
    },
    programmeBrief: {
      required: requiredIf(requireProgrammeBrief),
      fileType: fileType(["pdf", "doc", "docx"]),
      fileSizeMin: fileSizeMin(1),
      fileSizeMax: fileSizeMax(20 * 1024 * 1024)
    }
  }
};

export { step4Validations, step4 };
